export default __webpack_public_path__ + "static/InterDisplay-SemiBoldItalic-91d57cc3bb2005e62052b627ed92ca19.woff";